import { jsx as _jsx } from "react/jsx-runtime";
// Copyright 2022 The Parca Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
import { createContext, useContext } from 'react';
export const defaultValue = {
    profileSource: undefined,
    compareMode: false,
};
const ProfileViewContext = createContext(defaultValue);
export const ProfileViewContextProvider = ({ children, value, }) => {
    return (_jsx(ProfileViewContext.Provider, { value: { ...defaultValue, ...(value ?? {}) }, children: children }));
};
export const useProfileViewContext = () => {
    const context = useContext(ProfileViewContext);
    if (context == null) {
        return defaultValue;
    }
    return context;
};
export default ProfileViewContext;
